import { Component, OnInit } from '@angular/core';
import { AbstractControl, NgForm } from '@angular/forms';
import { SharedService } from '../../services/shared.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { MentorAuthService } from 'src/app/mentor/services/mentor-auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MentorService } from 'src/app/mentor/services/mentors.service';

@Component({
  selector: 'app-meeting-notes-window',
  templateUrl: './meeting-notes-window.component.html',
  styleUrls: ['./meeting-notes-window.component.css']
})
export class MeetingNotesWindowComponent implements OnInit {

  date: String = "";
  time: String = "";
  type: String = "";
  meetingId: string;
  documentId: String = "";
  mentorNote: String = "";
  action: String = "Add";
  scholarId: any;
  name: any;
  meetingNotes: any = [];
  mentorId: any;
  showSection: boolean = true;
  selectedFiles: any = [];
  filesArray: any = [];
  status: String;
  goal: String;
  scholarName: String;
  meetingDetails: any;
  noNote:boolean=false;
  noDocument:boolean=false;
  constructor(
    private sharedService: SharedService,
    private _snackBar: MatSnackBar,
    private matDialog: MatDialog,
    private mentorAuthService: MentorAuthService,
    private activateRoute: ActivatedRoute,
    private mentorService: MentorService,private router: Router
  ) {
    // @Inject(MAT_DIALOG_DATA)
    // public data: {
    //   meetingId: string;
    //   date: String;
    //   time: String;
    //   type: String;
    //   status: String;
    //   goal: String;
    //   mentorNotes: String;
    //   mentorId: String;
    //   name: String;
    // },
    // this.meetingId = data.meetingId;
    // // this.documentId=data.documentId;
    // this.type = data.type;
    // this.date = data.date;
    // this.time = data.time;
    // this.status = data.status;
    // this.goal = data.goal;
    // this.scholarName = data.name;
    // // this.scholarId=data.scholarId;
    // this.mentorId = data.mentorId;
    // // if(data.mentorNotes){
    // //   this.mentorNote=data.mentorNotes
    // //   this.action=''
    // // }
    // // else{
    // //   this.action='Add'
    // // }
  }

  ngOnInit() {
    this.meetingId = this.activateRoute.snapshot.queryParamMap.get("meetingId");
    this.getTaskDetails();
    this.getMeetingNotes();
    this.getMeetingDocuments();
  }
  getTaskDetails() {
    this.sharedService
      .getMeetingDetails(this.meetingId)
      .subscribe((data: any) => {
       
       const {meetingDetail,scholarName}=data;
        if (data) {
          this.type = meetingDetail[0].meetingType;
          this.date = meetingDetail[0].date;
          this.time = meetingDetail[0].time;
          this.status=meetingDetail[0].status;
          this.goal = meetingDetail[0].goal;
          this.scholarName = scholarName;
        }
      });
  }
  getMeetingNotes() {
    this.sharedService
      .getMeetingNotes(this.meetingId)
      .subscribe((data: any) => {
        if (data) {
          this.noNote=false;
          this.showSection = false;
          this.meetingNotes = data.meetingsNotes.map((note) => ({
            date: note.date,
            time: note.time,
            name: note.name,
            note: note.note,
          }));
        }else{
          this.noNote=true;
        }
      });
  }
  getMeetingDocuments() {
    this.sharedService
      .getMeetingDocuments(this.meetingId)
      .subscribe((result: any) => {
        if (result) {
          this.noDocument=false;
          const { meetingDocuments } = result;
          this.selectedFiles = meetingDocuments;
        } else {
          this.noDocument=true;
        }
      });
  }
  addNotes(form: NgForm) {
    if (form.valid) {
      const currentDateTime = new Date();
      const formattedDate = currentDateTime.toISOString().split("T")[0];
      const formattedTime = currentDateTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      const details = {
        meetingId: this.meetingId,
        meetingsNotes: {
          scholarId: this.scholarId,
          mentorId: this.mentorAuthService.getLoggedUserId(),
          name: this.mentorAuthService.getUserName(),
          date: new Date(),
          time: formattedTime,
          note: this.mentorNote,
        },
      };
      this.sharedService.setMentorNotes(details).subscribe(
        (result: any) => {
          if (result) {
            this.mentorNote='';
            this.noNote=false;
            this.showSection = false;
            this.meetingNotes.push(result.data);
            this.openSnackBar("Saved successfully", "close");
          }else{
            this.noNote=true;
          }
        },
        (error) => {
          this.openSnackBar("oops something went wrong", "close");
          console.log(error);
        }
      );
    } else {
      return false;
    }
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }
  trim(control: AbstractControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
  onFileSelected(event: any) {
    const files = event.target.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.convertToBase64(file);
      }
    }
  }
  convertToBase64(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result as string;
      const currentDateTime = new Date();
      const formattedDate = currentDateTime.toISOString().split("T")[0];
      const formattedTime = currentDateTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      let details = {
        meetingId: this.meetingId,
        meetingDocuments: {
          scholarId: this.scholarId,
          mentorId: this.mentorAuthService.getLoggedUserId(),
          name: this.mentorAuthService.getUserName(),
          date: new Date(),
          time: formattedTime,
          documents: [
            {
              file: base64String,
              name: file.name,
              size: file.size,
            },
          ],
        },
      };

      this.sharedService.uploadFiles(details).subscribe((result: any) => {
        if (result) {
          this.noDocument=false;
          this.selectedFiles.push(result.data);
          this.openSnackBar("File uploaded successfully", "close");
        }else{
          this.noDocument=true;
        }
      });
    };
    reader.readAsDataURL(file);
  }
  downloadDocument(files) {
    const base64String = files.documents[0].file.split(",")[1];
    this.downloadFile(base64String, files.documents[0].name);
  }
  downloadFile(base64String: string, fileName: string) {
    const byteCharacters = atob(base64String);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: "application/octet-stream" });

    // Create a Blob URL
    const blobUrl = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;

    // Programmatically trigger the download
    document.body.appendChild(link); // Append the link to the DOM (required in some browsers)
    link.click();

    // Clean up the Blob URL and remove the link element
    document.body.removeChild(link); // Remove the link from the DOM
    URL.revokeObjectURL(blobUrl);
  }
  navigateBack(){
   
    if(this.router.url.includes('/scholar/task/documents')){
      console.log("true")
      this.router.navigate(['/scholar/meetings/notes']);
    }else{
      this.router.navigate(['/mentor/meetings/notes']);
    }
    
  }
}
